import { TYPES } from "../reducers/chatsWithNewMessages";

export const chatWithNewMessage = (chatId: string) => {
    return {
        type: TYPES.ADD,
        payload: chatId
    }
}

export const removeChatIdFromTheList = (chatId: string) => {
    return {
        type: TYPES.REMOVE,
        payload: chatId
    }
}